import React, { useRef } from 'react'

import { GoogleMap } from '@react-google-maps/api'
import PropTypes from 'prop-types'

import { Grid } from '@material-ui/core'

import { GridContainer, StyledButton } from './theme'

const DEFAULT_CONTAINER_STYLE = {
  width: '100%',
  height: '79vh'
}

const DEFAULT_CENTER = {
  lat: -24.6549877,
  lng: -54.6549877
}

export const DEFAULT_ZOOM = 14

const GoogleMaps = ({
  children,
  isLoaded,
  setZoom,
  ...props
}) => {
  const mapInstance = useRef(null)

  const handleChangeZoom = evt => {
    const type = evt.target.parentNode.id

    const currentZoom = mapInstance.current.getZoom()
    if (type === 'increment') {
      mapInstance.current.setZoom(currentZoom + 1)
      return
    }

    mapInstance.setZoom(currentZoom - 1)
  }

  const handleMapLoaded = map => {
    mapInstance.current = map
  }

  const handleZoomChanged = () => {
    if (mapInstance.current)
      setZoom(mapInstance.current.getZoom())
  }

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={ DEFAULT_CONTAINER_STYLE }
      center={ DEFAULT_CENTER }
      zoom={ DEFAULT_ZOOM }
      onLoad={ handleMapLoaded }
      onZoomChanged={ handleZoomChanged }
      options={ {
        fullscreenControl: false,
        streetViewControl: false,
        disableDefaultUI: true,
        mapTypeId: 'satellite'
      } }
      { ...props }
    >
      {children}
      <GridContainer container direction="column">
        <Grid item>
          <StyledButton id="increment" onClick={ handleChangeZoom }>+</StyledButton>
        </Grid>
        <Grid item>
          <StyledButton id="decrement" onClick={ handleChangeZoom }>-</StyledButton>
        </Grid>
      </GridContainer>
    </GoogleMap>
  ) : null
}

GoogleMaps.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  isLoaded: PropTypes.bool.isRequired,
  setZoom: PropTypes.func
}

GoogleMaps.defaultProps = {
  children: <></>,
  setZoom: () => {}
}

export default React.memo(GoogleMaps)
